var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "34px",
    viewBox: "0 0 33 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13-copy",
    transform: "translate(-1065.000000, -233.000000)",
    fill: "#FAFAFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(1065.000000, 233.748603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 7.61538462 7.61538462 7.61538462 7.61538462 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "25.3846154 7.61538462 33 7.61538462 33 0 25.3846154 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "12.6923077 7.61538462 20.3076923 7.61538462 20.3076923 0 12.6923077 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "0 20.3076923 7.61538462 20.3076923 7.61538462 12.6923077 0 12.6923077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "25.3846154 20.3076923 33 20.3076923 33 12.6923077 25.3846154 12.6923077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "12.6923077 20.3076923 20.3076923 20.3076923 20.3076923 12.6923077 12.6923077 12.6923077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "0 33 7.61538462 33 7.61538462 25.3858846 0 25.3858846"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "25.3846154 33 33 33 33 25.3858846 25.3846154 25.3858846"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "12.6923077 33 20.3076923 33 20.3076923 25.3858846 12.6923077 25.3858846"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.4ff36e54f817ea3bd349392ba1548e28.svg";
export { ForwardRef as ReactComponent };